export enum DisableManifestReason {
  LOADING_CARGO = 'Cargando información...',
  NO_MANIFEST_RNDC = 'No se ha transmitido el manifiesto al RNDC',
  SHOW_MANIFEST = 'Ver manifiesto',
  PRECONDITIONS_NOT_MET = 'No es posible ver el manifiesto'
}
